if (!customElements.get('grid-view-switcher')) {
  customElements.define(
    'grid-view-switcher',
    class GridViewSwitcher extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section');
        this.buttons = this.querySelectorAll('button');
        this.wrapper = this.querySelector('.grid-view-switcher__wrapper');

        this.buttons.forEach((button) => {
          button.addEventListener('click', this.handleButtonClick.bind(this));
        });
      }

      handleButtonClick(event) {
        event.preventDefault();
        const button = event.currentTarget;
        const view = button.dataset.view;

        this.updateHighlighterPosition(button);
        this.updateView(view);
      }

      updateHighlighterPosition(button) {
        this.wrapper.style.setProperty('--highlighter-offset', `${button.offsetLeft}px`);
      }

      updateView(view) {
        const productsGrid = this.section.querySelector('#product-grid');
        const currentClasses = productsGrid.className;
        const newClasses = currentClasses.replace(/(small-up-)\d+/, `$1${view}`);
        productsGrid.className = newClasses;
      }
    }
  );
}